<template>
  <div class="grade-student-picker">
    <div class="grade-student-search">
      <v-text-field v-model.trim="search" outlined dense clearable hide-details prepend-inner-icon="mdi-magnify" placeholder="Search students by name" />
      <span v-if="filteredStudents.length">{{ filteredStudents.length }} found</span>
    </div>
    <div v-if="isLoading" class="teacher-loading-state"><v-progress-circular size="34" width="3" color="primary" indeterminate /><strong>Loading students</strong></div>
    <div v-else-if="filteredStudents.length" class="grade-choice-list grade-student-list">
      <button v-for="(item, index) in filteredStudents" :key="studentKey(item, index)" type="button" @click="studentSelected(item)">
        <span class="teacher-student-row__avatar">{{ initials(item.fullName) }}</span>
        <span><strong>{{ item.fullName }}</strong><small>Select to enter or review grades</small></span>
        <v-icon size="19" color="#96a29a">mdi-chevron-right</v-icon>
      </button>
    </div>
    <div v-else class="grade-setup-empty">
      <span><v-icon size="30" color="#2f7d4a">mdi-account-search-outline</v-icon></span>
      <h3>{{ search ? "No matching students" : "No students available" }}</h3>
      <p>{{ search ? "Try a different name." : "Add students to this classroom before entering grades." }}</p>
    </div>
  </div>
</template>

<script>
import studentService from "@/modules/Students/service.js";
import sortStudentsByName from "@/utils/sortStudentsByName.js";
export default {
  name: "student-list",
  props: { ClassroomId: { default: null }, ClassId: { default: null } },
  data() { return { students: [], search: "", isLoading: false, mode: "classroom" }; },
  computed: {
    filteredStudents() {
      const query = (this.search || "").toLowerCase().trim();
      const matches = query
        ? this.students.filter(student => String(student.fullName || "").toLowerCase().includes(query))
        : this.students;
      return sortStudentsByName(matches);
    },
  },
  watch: {
    ClassroomId: { immediate: true, handler() { this.mode = this.ClassroomId ? "classroom" : "department"; this.getList(); } },
    ClassId() { if (!this.ClassroomId && this.ClassId) this.getList(); },
  },
  methods: {
    initials(name) { return name ? name.split(" ").filter(Boolean).slice(0, 2).map(part => part.charAt(0)).join("").toUpperCase() : "S"; },
    studentKey(item, index) { return item.id || item.StudentId || `${item.fullName || "student"}-${index}`; },
    getList() {
      const params = this.ClassroomId ? { ClassRoomId: this.ClassroomId } : this.ClassId ? { ClassId: this.ClassId } : null;
      if (!params) { this.students = []; return; }
      this.isLoading = true;
      return studentService.getAll(params)
        .then(response => { this.students = response && response.data ? response.data : []; return response; })
        .catch(() => { this.students = []; })
        .finally(() => { this.isLoading = false; });
    },
    studentSelected(student) { this.$emit("studentSelected", student); },
  },
};
</script>
